// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PlanGroupListController = function ($scope, $http, $location, PlanGroup, gettextCatalog, gettext) {

    if (!$scope.search)
        $scope.search = "";
    $scope.showHidden = false;
    $scope.wasSearching = false;

    $scope.updateFilter = function () {
        $scope.planGroups = $scope.paginator(function (options, callback) {
            return PlanGroup.query(options, function () {
                callback();
                $scope.wasSearching = options.search;
            });
        }, getSearchParams(), 20);
    };

    $scope.deletePlanGroup = function(planGroupId) {
        confirm(gettextCatalog.getString(gettext('Please remove all related products (except the default price list)' +
                ' before attempting to delete the plan group.')),
            function() {
                PlanGroup.remove({ planGroupId: planGroupId }, function() {
                    $scope.updateFilter();
                });
            });
    };

    $scope.hideShowItems = function () {
        $scope.showHidden = !$scope.showHidden;
        $scope.updateFilter();
    };

    $scope.hidePlanGroup = function (id) {
        confirm(gettextCatalog.getString(gettext('You are about to hide an item.')),
            function() {
                changePlanGroupVisibility(id, true);
            });
    };

    $scope.unhidePlanGroup = function (id) {
        confirm(gettextCatalog.getString(gettext('You are about to make an item visible again.')),
            function() {
                changePlanGroupVisibility(id, false);
            });
    };

    function getSearchParams() {
        return {
            search: $scope.search,
            showHidden: $scope.showHidden,
        };
    }

    function confirm(header, deleteCallback) {
        $scope.yesCancel(header, gettextCatalog.getString(gettext('Are you sure?')), function() { deleteCallback(); });
    }

    function changePlanGroupVisibility(id, hide) {
        $http({
            method: "POST",
            url: `/api/v1/planGroups/${id}/visibility`,
            data: { "id": id, "hidden": hide },
            headers: { "Content-Type": "application/json" },
            cache: false
        }).then(function () {
            $scope.updateFilter();
        });
    }

    $scope.updateFilter();
};
PlanGroupListController.$inject = ['$scope', '$http', '$location', 'PlanGroup', 'gettextCatalog', 'gettext'];
